import styles from './BgVideo.module.css';

import bgVideo from '../../assets/video/bgVideo.webm';
import { useEffect, useRef } from 'react';

export const BgVideo = ({ delay }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.play();
      }
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={styles.bgVideoWrapper}>
      <video ref={videoRef} playsInline autoPlay={false} muted="muted">
        <source src={bgVideo} type="video/webm" />
      </video>
    </div>
  );
};
